import { signal } from '@preact/signals';
import { Brand } from 'cosdb-types';

export const brandsSignal = signal<Brand[]>([]);

export const brandNameById = (brandId?: string) =>
  brandsSignal.value.find((b) => b.id === brandId)?.value;
